"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../scss/main.scss");
var Carousel;
(function (Carousel) {
    const $carousels = document.querySelectorAll('.carousel-component');
    if ($carousels.length) {
        $carousels.forEach(($carousel) => {
            let perView;
            const $glide = new Glide($carousel.querySelector('.glide'), {
                type: 'slider',
                perView: 2,
                startAt: 0,
                bound: true,
                rewind: false,
                peek: {
                    before: 0,
                    after: 150
                },
                gap: 25,
                breakpoints: {
                    1024: {
                        gap: 18,
                        peek: {
                            before: 0,
                            after: 70
                        }
                    },
                    678: {
                        perView: 1,
                        gap: 15,
                        peek: {
                            before: 15,
                            after: 35
                        }
                    }
                }
            });
            perView = $glide.settings.perView;
            $glide.mount();
            const $slider = $carousel.querySelector('.glide__slides');
            const $slides = $slider.querySelectorAll('.glide__slide');
            const $first = $slides[0];
            const $last = $slides[$slides.length - perView - 1];
            const $dirLeft = $carousel.querySelector('.dir.left');
            const $dirRight = $carousel.querySelector('.dir.right');
            function bind() {
                $dirRight.addEventListener('click', () => {
                    $dirLeft.classList.remove('is-disabled');
                    if ($last.classList.contains('glide__slide--active')) {
                        $dirRight.classList.add('is-disabled');
                    }
                });
                $dirLeft.addEventListener('click', () => {
                    $dirRight.classList.remove('is-disabled');
                    if ($first.classList.contains('glide__slide--active')) {
                        $dirLeft.classList.add('is-disabled');
                    }
                });
                $slides.forEach(($slide) => {
                    $slide.addEventListener('mousemove', () => {
                        $dirRight.classList.remove('is-disabled');
                        $dirLeft.classList.remove('is-disabled');
                        if ($first.classList.contains('glide__slide--active')) {
                            $dirLeft.classList.add('is-disabled');
                            $dirRight.classList.remove('is-disabled');
                        }
                        else if ($last.classList.contains('glide__slide--active')) {
                            $dirRight.classList.add('is-disabled');
                            $dirLeft.classList.remove('is-disabled');
                        }
                    });
                });
            }
            function init() {
                $dirLeft.classList.add('is-disabled');
                bind();
            }
            init();
        });
    }
})(Carousel || (Carousel = {}));
